import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "../lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null=checking, false=anon, obj=authed
  const [ready, setReady] = useState(false);

  const loadMe = useCallback(async () => {
    const t = localStorage.getItem("arv_token");
    if (!t) { setUser(false); setReady(true); return; }
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch {
      localStorage.removeItem("arv_token");
      setUser(false);
    } finally {
      setReady(true);
    }
  }, []);

  useEffect(() => { loadMe(); }, [loadMe]);

  const loginSuccess = (token, u) => {
    localStorage.setItem("arv_token", token);
    setUser(u);
  };

  const logout = () => {
    localStorage.removeItem("arv_token");
    setUser(false);
    window.location.assign("/");
  };

  return (
    <AuthContext.Provider value={{ user, ready, setUser, loginSuccess, logout, refresh: loadMe }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
